import { Container, Shimmer, Spacer, Typography } from '@/src/ct-design/lib'
import { TypographyVariantType } from '@/src/ct-design/lib/Typography/type'
const VisaCardShimmer = ({
    titleVariant,
    className
}: {
    titleVariant: TypographyVariantType
    className: string
}) => {
    return (
        <Container className='mt-6'>
            <Typography variant={titleVariant}>
                Your Visa Application
            </Typography>
            <Spacer className='mb-5' />
            <Container
                className={`flex flex-column ba-solid br-8 bc-line-500 mr-4 ${className}`}
                width='330px'
                style={{
                    minWidth: '330px'
                }}
            >
                <Container className='flex flex-1 flex-between mb-3'>
                    <Shimmer height='28px' width='101px' borderRadius='8px' />
                    <Spacer className='mr-1' />
                    <Shimmer height='28px' width='101px' borderRadius='8px' />
                </Container>

                <Container className='flex flex-1 flex-between mt-3'>
                    <Shimmer height='28px' width='101px' borderRadius='8px' />
                    <Shimmer height='28px' width='101px' borderRadius='8px' />
                </Container>
                <Container className='flex flex-1 flex-between mt-3'>
                    <Shimmer height='28px' width='101px' borderRadius='8px' />
                    <Shimmer height='28px' width='101px' borderRadius='8px' />
                </Container>
                <Container className='flex flex-1 flex-between mt-3'>
                    <Shimmer height='28px' width='101px' borderRadius='8px' />
                    <Shimmer height='28px' width='101px' borderRadius='8px' />
                </Container>
                <Container className='flex flex-1 flex-between mt-3'>
                    <Shimmer height='28px' width='101px' borderRadius='8px' />
                    <Shimmer height='28px' width='101px' borderRadius='8px' />
                </Container>
                <Container className='flex flex-1 flex-between mt-3'>
                    <Shimmer height='28px' width='101px' borderRadius='8px' />
                    <Shimmer height='28px' width='101px' borderRadius='8px' />
                </Container>
                <Container className='flex flex-1 flex-between mt-3'>
                    <Shimmer height='28px' width='101px' borderRadius='8px' />
                    <Shimmer height='28px' width='101px' borderRadius='8px' />
                </Container>
                <Container className='flex flex-1 flex-center mt-6'>
                    <Shimmer height='28px' width='101px' borderRadius='8px' />
                </Container>
            </Container>
        </Container>
    )
}

export default VisaCardShimmer
